/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const PetHealthContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 32px 40px 8px 40px;
  padding: 16px;
  background: ${props => (props.$isMadPawsStore ? 'var(--primary-light-6x)' : 'var(--grey-04)')};
  border-radius: 8px;
  line-height; 22.4px;
  & > svg {
    overflow: visible !important;
    margin-right: 16px;
  }
  @media screen and (max-width: 992px) {
    padding: 16px; 
    margin: 32px 24px 8px 24px;
  }
  `;

export const AutoShipBtnContainer = styled.div`
  button {
    margin-top: 10px;
    white-space: ${props => (props.$isMobile ? 'break-spaces' : 'nowrap')};
  }
`;

export const RecommendationContainer = styled.div`
  ${props =>
    props.$hideSWidget
      ? 'margin-bottom: 170px;  @media screen and (max-width: 992px) { margin-bottom: 151px;} @media screen and (max-width: 400px) {margin-bottom: 163px;}'
      : 'margin-bottom: 330px;'};
`;

export const OGOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  & > label {
    margin: 10px 0;
  }
`;

export const AddToCartContainer = styled.div`
  position: relative;
  flex: 1;
`;

export const ProductImageContainer = styled.div`
  display: flex;
  margin-top: 50px;
  gap: 1rem;
  max-height: 418px;
  overflow: hidden;

  .colThumbnails {
    width: 70px;
    flex: none;
    max-height: 518px;
  }
  .colThumbnails :global(.slick-up.disabled),
  .colThumbnails :global(.slick-down.disabled) {
    color: #c9d5da;
    cursor: not-allowed;
  }
  .colThumbnails :global(.slick-up) {
    transform: rotate(180deg);
  }

  .colThumbnails :global(.slick-slider) {
    text-align: center;
  }

  .colImages {
    /* flex: 1; */

    line-height: 0px;
    width: 100%;
    max-width: 550px;
    padding-right: 2rem;
    margin: auto;
    position: relative;
    height: 100%;
  }

  .colImages img {
    width: 100%;
    max-width: 100%;
    margin: 0px;
  }

  @media (max-width: 1279px) {
    .colImages {
      max-width: 440px;
      margin: auto;
    }
  }
  @media (max-width: 800px) {
    flex-direction: column;
    margin-top: 0;
    .colThumbnails {
      display: none;
    }

    .colThumbnails [class^='sticky-outer-wrapper'] {
      height: auto !important;
    }

    .colThumbnails [class^='sticky-inner-wrapper'] {
      position: relative !important;
      transform: none !important;
      top: 0px !important;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
      gap: 15px;
      margin-bottom: 15px;
    }

    .colThumbnails[data-img-count='1'] [class^='sticky-outer-wrapper'] {
      display: none;
    }

    .colImages {
      order: 1;
      padding-left: 0px;
      padding-right: 0px;
      position: relative;
      min-height: 100px;

      img {
        height: 269px;
        width: 269px;
        object-fit: contain;
        margin-left: auto;
        margin-right: auto;
      }
    }

    .colImages > div[class*='ProductImages-module--productImageActive-'] {
      display: block;
      position: relative;
      opacity: 1;
      visibility: visible;
      z-index: 1;
    }
  }
`;

export const ProductGiftContainer = styled.div`
  display: flex;
  position: relative;
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;

  .productTopEntry {
    width: 100%;
    // display: grid;
    // grid-template-columns: repeat(2, 1fr);
    display: flex;
    flex-direction: column;
    gap: 19px;
    & > div {
      margin-top: 0;
    }
  }
  .productTopCol {
    box-sizing: border-box;
  }

  .colDetails {
    flex: none;
    max-width: 440px;
    margin: 0 auto;
    width: 100%;
    padding-top: 1rem;
    padding-bottom: 1.5rem;
  }

  .productTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
  }

  .outOfStock {
    border-radius: 4px;
    background: var(--navy-01, #eaeff1);
    padding: 11px 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    gap: 1rem;

    p {
      color: var(--charcoal-01, #202020);
      font-size: 14px;
      font-style: normal;
      font-weight: bold;
      line-height: 140%;
      /* 19.6px */
    }

    button {
      width: 125px;
    }
  }
  @media (max-width: 1145px) {
    .colDetails {
      max-width: 350px;
      width: 100%;
    }
  }
  @media only screen and (max-width: 800px) {
    .productTop {
      display: block;
    }

    .productTopEntry {
      display: flex;
      flex-direction: column;
      gap: 19px;
    }

    .colDetails {
      order: 3;
      max-width: none;
      background-color: #f9fbfd;
      box-shadow: 0 0 0 100vmax #f9fbfd;
      clip-path: inset(0 -100vmax);
      padding-top: 1.5rem;
      h1 {
        font-size: 18px;
      }
    }

    .colDetails [class^='sticky-inner-wrapper'] {
      transform: none !important;
    }
  }
`;
